module.exports = __webpack_public_path__ + "static/img/active_09.379f251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_09.jpg
// module id = ohxw
// module chunks = 0